import {
  DataValueFormatter,
  DomUtil
} from "cartovista";
import SearchableTreeView from "../appTools/SearchableTreeView";
import {createFeatures, createDataRows} from "../utils/CvUtils";
import "../../css/searchView.css";﻿

   export default class SearchView extends SearchableTreeView{
      constructor() {
        super(true, true, true, false);
        new Promise(function(resolve, reject) {
            if (!window.cartovista.getMap(C.MAP.ID)) {
                window.cartovista.addOneTimeEventListener(cartovista.EVENTS.MAP_LOADED + "_" + C.MAP.ID, resolve, this);
            } else {
                resolve();
            }
        }).then(function() {
            this._map = window.cartovista.getMap(C.MAP.ID);
            this._layers = this.getSearchableLayers();
            this._layersFromWebService = ["GEOCODER_ADRS", "GEOCODER_CP"];

            $("#SearchView_panel_btn").html('<span class="k-sprite cv-icon cv-icon-search"></span>');
            this.genericView = window.cartovista.getUIController(this._map).findInstance("SearchView_panel");
            this.genericView._activated = this._activated.bind(this);

            this._mapController = window.cartovista.getMapController(this._map);

            $(this.genericView.element).html(this._$container);
            this._dataSource.read();
        }.bind(this));
      }

    _activated() {
        this._$searchInput.focus();
    };

    getSearchableLayers() {
        return _.reduce(this._map.layers, function(searchableLayers, layer){
            if(layer.isSearchable){
                searchableLayers.push(layer);
            }
            return searchableLayers;
        }, []);
    };

    _onDataBound(e) {
        var dataItem = this._listSearch ? this._listSearch.dataItem(e.node) : null;
        if(dataItem){
            $(e.node).find(".k-item").hover(this._onHoveredRowIn_listSearch.bind(this), this._onHoveredRowOut_listSearch.bind(this));;
        }
        if(!dataItem && this._$searchInput.val()){
            this._listSearch.expand(".k-item");
        }
        if(dataItem && dataItem.children.total() == 0) {
            this._listSearch.remove(e.node);
        }
    };

    _kendoTransportRead(e) {
        if(typeof e.data.id !== "undefined"){
            this.queryLayerData(e);
        } else{
            this.queryLayers(e);
        }
    };

    queryLayers(readEvent) {
        Promise.all(_.map(_.reverse(_.clone(this._layers)), function(layer) {
            return {
                text: layer.name,
                id: layer.id,
                hasChildren: true
            };
        })).then(function(result){
            readEvent.success(result);
        });
    }

    queryLayerData(readEvent) {
        var searchCriteria = this._$searchInput.val();
        if(_.includes(this._layersFromWebService, readEvent.data.id)){
            if(searchCriteria){
                this._getAttributeValuesFromWebService(_.find(this._layers, {id: readEvent.data.id}), searchCriteria).then(function(items){
                    readEvent.success(items);
                });
            } else{
                readEvent.success([{
                    text: "Effectuer une recherche pour obtenir un résultat",
                    hasChildren: false
                }]);
            }
        } else{
            this._getAttributeValuesFromMapLayer(_.find(this._layers, {id: readEvent.data.id}), searchCriteria).then(function(items){
                readEvent.success(items);
            });
        }
    }

    _getAttributeValuesFromMapLayer(layer, searchCriteria) {
        var dataQuery = layer.createDataQuery(layer.searchableDataColumns);
        dataQuery.searchCriteria = searchCriteria;
        if (layer.searchableDataColumns){
            _.forEach(layer.searchableDataColumns, function(searchableDataColumn){
                dataQuery.sortBy(searchableDataColumn, "ASCENDING");
            });
        }
        return new Promise(function(resolve, reject) {
            dataQuery.execute(resolve, this);
        }).then(function(dataQueryResult) {
            return _.orderBy(_.map(dataQueryResult.linkingIds, function(linkingId, idx){
                return {
                    featureId: linkingId,
                    id: linkingId,
                    text: _.map(layer.searchableDataColumns, function(searchableDataColumn){
                        return DataValueFormatter.formatValue(dataQueryResult.values[searchableDataColumn.dataTable.id][searchableDataColumn.id][idx], searchableDataColumn);
                    }).join(" - "),
                    layerId: layer.id,
                    hasChildren: false
                };
            }), "text");
        });
    };

    _getAttributeValuesFromWebService(layer, searchCriteria) {
        return new Promise(function(resolve, reject) {
            $.ajax({
                method: "GET",
                contentType: "text/plain",
                url: C.URLS.SEARCH_VIEW[layer.id],
                data: C.LAYERS[layer.id].SEARCH_VIEW.QUERY_DATA(searchCriteria),
                success: function(results){
                    resolve(results);
                },
                error: function(jqXHR, textStatus, error) {
                    console.error(jqXHR, textStatus, error);
                    reject(error);
                }
            });
        }).then(function(results) {
            return _.orderBy(_.map(results.features, function(feature){
                return {
                    featureId: C.LAYERS[layer.id].SEARCH_VIEW.CALCUL_FEATURE_ID(feature),
                    id: C.LAYERS[layer.id].SEARCH_VIEW.CALCUL_FEATURE_ID(feature),
                    text: C.LAYERS[layer.id].SEARCH_VIEW.CALCUL_FEATURE_TEXT(feature),
                    layerId: layer.id,
                    geometry: C.LAYERS[layer.id].SEARCH_VIEW.CALCUL_GEOMETRY(feature),
                    hasChildren: false
                };
            }.bind(this)), 'text');
        }.bind(this));
    };

    _addFeatureToLayer(item) {
        return new Promise(function(resolve, reject) {
            var layer = this._map.getLayer(item.layerId);
            var layerConfig = C.LAYERS[item.layerId];
            var featureData = [];
            featureData = [{
                geometry : item.geometry,
                attributes : {
                    ID : item.featureId,
                    TEXT : item.text
                }
            }];
            if(layerConfig){
                var features = createFeatures(layerConfig, featureData);
                var dataRows = createDataRows(layerConfig, featureData, _.map(features, "id"));
                layer.addFeatures(features);
                layer.getDataTable(layerConfig.DATATABLE_ID).addDataRows(dataRows);
                resolve(features);
            } else{
                reject();
            }
        }.bind(this));
    };

    _onSelectedItem_listSearch(item){
        if(item.layerId) this._map.getLayer(item.layerId).getSimpleFeaturesExtents([item.featureId], this._onGetFeaturesByIdCallback.bind(this, item), this)
      }

    _onGetFeaturesByIdCallback(item, extent) {
        if(extent.extents.length){
            this._mapController.zoomOnExtents(extent.extents, extent.layer);
        } else{
            this._addFeatureToLayer(item).then(function(features){
                this._mapController.zoomOnFeatures(features, extent.layer);
            }.bind(this));
        }
        if(DomUtil.isResponsiveUI()){
            this.genericView.deactivate();
        }
    };
}
